import { TruckIcon, BuildingOffice2Icon } from "@heroicons/react/24/outline";
import { Modal } from "../molecules/Modal";

export interface StaffViewSelectorProps {
  onSelect: (view: "delivery" | "operations") => void;
}

export function StaffViewSelector({ onSelect }: StaffViewSelectorProps) {
  const handleSelect = (view: "delivery" | "operations") => {
    localStorage.setItem("staff_view_preference", view);
    onSelect(view);
  };

  return (
    <Modal
      isOpen={true}
      onClose={() => {
        /* Cannot be dismissed without selection */
      }}
      title="Choose Your Workspace"
      description="Select the interface that best fits your role"
      size="lg"
      showCloseButton={false}
    >
      <div className="px-5 py-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Delivery View Card */}
          <button
            onClick={() => handleSelect("delivery")}
            className="flex flex-col items-center p-6 border-2 border-neutral-200 dark:border-neutral-700 rounded-xl 
                     hover:border-primary-500 dark:hover:border-primary-500 hover:bg-primary-50 dark:hover:bg-primary-900/20 
                     transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 
                     dark:focus:ring-offset-neutral-800"
          >
            <div className="w-16 h-16 mb-4 flex items-center justify-center rounded-full bg-primary-100 dark:bg-primary-900/30 text-primary-600 dark:text-primary-400">
              <TruckIcon className="w-8 h-8" />
            </div>
            <h3 className="text-lg font-semibold text-neutral-900 dark:text-neutral-100 mb-2">
              Delivery View
            </h3>
            <p className="text-sm text-neutral-600 dark:text-neutral-400 text-center">
              Quick deliveries & sales
            </p>
            <p className="text-xs text-neutral-500 dark:text-neutral-500 text-center mt-2">
              Optimized for mobile delivery and on-the-spot orders
            </p>
          </button>

          {/* Operations View Card */}
          <button
            onClick={() => handleSelect("operations")}
            className="flex flex-col items-center p-6 border-2 border-neutral-200 dark:border-neutral-700 rounded-xl 
                     hover:border-primary-500 dark:hover:border-primary-500 hover:bg-primary-50 dark:hover:bg-primary-900/20 
                     transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 
                     dark:focus:ring-offset-neutral-800"
          >
            <div className="w-16 h-16 mb-4 flex items-center justify-center rounded-full bg-primary-100 dark:bg-primary-900/30 text-primary-600 dark:text-primary-400">
              <BuildingOffice2Icon className="w-8 h-8" />
            </div>
            <h3 className="text-lg font-semibold text-neutral-900 dark:text-neutral-100 mb-2">
              Operations View
            </h3>
            <p className="text-sm text-neutral-600 dark:text-neutral-400 text-center">
              Orders, Inventory, Production
            </p>
            <p className="text-xs text-neutral-500 dark:text-neutral-500 text-center mt-2">
              Full operational access for warehouse and production staff
            </p>
          </button>
        </div>
      </div>
    </Modal>
  );
}
